// extracted by mini-css-extract-plugin
export default {"features":"Features_features__ls4e9","icon":"Features_icon__kkrgO"};